<header #heading class="≈font-apple-system ≈block" [ngClass]="{
    '≈tracking-normal': trackingIs(UIHeadingTracking.normal),
    '≈tracking-wide': trackingIs(UIHeadingTracking.wide),
    '≈tracking-wider': trackingIs(UIHeadingTracking.wider),
    '≈tracking-widest': trackingIs(UIHeadingTracking.widest),
    '≈text-subdued-text ≈uppercase': headingStyle === 'uppercase-wide',
    '≈text-default-text': headingStyle === 'normal',
    '≈text-base lg:≈text-lg 2xl:≈text-xl': size === 'medium',
    '≈text-xs lg:≈text-sm 2xl:≈text-base': size === 'small',
    '≈text-lg lg:≈text-xl 2xl:≈text-2xl': size === 'large',
    '≈mb-2.5 sm:≈mb-3 md:≈mb-3.5 lg:≈mb-4 xl:≈mb-5': margin,
    '≈font-semibold': bold
}">
    <ng-content>

    </ng-content>
</header>
